/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Pronunciation_BodyInputs */

const en_why_listening_pronunciation_body = /** @type {(inputs: Why_Listening_Pronunciation_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for scientific terms. If a word comes out wrong, report it.`)
};

const es_why_listening_pronunciation_body = /** @type {(inputs: Why_Listening_Pronunciation_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensado para términos científicos. Si una palabra suena mal, repórtala.`)
};

/**
* | output |
* | --- |
* | "Built for scientific terms. If a word comes out wrong, report it." |
*
* @param {Why_Listening_Pronunciation_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_pronunciation_body = /** @type {((inputs?: Why_Listening_Pronunciation_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Pronunciation_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_pronunciation_body(inputs)
	return en_why_listening_pronunciation_body(inputs)
});